// extracted by mini-css-extract-plugin
export default {"container":"WebAboutUsScreen_container__ebkGl","gaplessBox":"WebAboutUsScreen_gaplessBox__XaD5g"};